import { reactQueryUtils } from "@/lib/react-query";
import { aiKeys, useGenerateImageMutation } from "@/shared/services";
import { toast } from "react-toastify";
import { OPTIONS_CONFIG } from "../constants";
import { useAiImageStoreShallow } from "../store";

export const useGenerateImage = () => {
  const { mutateAsync: generateImage, isPending } = useGenerateImageMutation();

  const {
    prompt,
    type,
    layout,
    aspectRatio,
    style,
    view,
    background,
    colors,
    colorsMode,
    model,
    variant,
    referenceImages,
    setMediaFile,
    reset,
  } = useAiImageStoreShallow((s) => ({
    prompt: s.prompt,
    type: s.type,
    layout: s.layout,
    aspectRatio: s.aspectRatio,
    style: s.style,
    view: s.view,
    background: s.background,
    colors: s.colors,
    colorsMode: s.colorsMode,
    model: s.model,
    variant: s.variant,
    referenceImages: s.referenceImages,
    setMediaFile: s.setMediaFile,
    reset: s.reset,
  }));

  const handleGenerateImage = async () => {
    if (isPending) return;
    try {
      const config = OPTIONS_CONFIG[type as keyof typeof OPTIONS_CONFIG];
      const styleValue = config.styles.find((s) => s.value === style)?.label;

      const { limits, images: generatedImages } = await generateImage({
        prompt: prompt,
        type,
        model,
        images: referenceImages.map((image) => image.url),
        settings: {
          layout,
          aspectRatio,
          style: styleValue,
          view,
          background,
          colors: colorsMode === "manual" ? colors : [],
          variant,
        },
      });
      if (typeof limits === "object" && limits !== null) {
        reactQueryUtils.setQueryData([...aiKeys.limitations("image")], limits);
      }
      if (generatedImages.length > 0) {
        setMediaFile(generatedImages[0].mediaFile);
      } else {
        throw new Error("No images generated");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate image, try again");
      reset();
    }
  };

  return { handleGenerateImage, isPending };
};
